import { Component, inject, OnInit, signal } from '@angular/core';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { RiskModel } from '../../../models/risk.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';
import { NgxCheckboxComponent } from '@digipay/ngx-checkbox';

@Component({
  selector: 'app-risk-bottom-sheet',
  standalone: true,
  imports: [PipesModule, NgxButtonComponent, MatCheckboxModule, NgxCheckboxComponent],
  templateUrl: './risk-bottom-sheet.component.html',
  styleUrl: './risk-bottom-sheet.component.scss',
})
export class RiskBottomSheetComponent implements OnInit {
  agreementChecked = signal<boolean>(false);
  data = signal<RiskModel | undefined>(undefined);
  private bottomSheet = inject(NgxBottomSheetService);

  ngOnInit() {
    this.data.set(this.bottomSheet.data());
  }

  onToggleAgreement(event: any) {
    this.agreementChecked.set(event);
  }

  close() {
    this.bottomSheet.outputData.set(true);
    this.bottomSheet.closeBottomSheet();
  }
}
